import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const DownIcon = (props: Props) => {
    const { color = '#444444', width = 8, height = 5, ...rest } = props;

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 8 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M3.97233e-08 1.17622e-06L8 -4.76837e-07L4 5L3.97233e-08 1.17622e-06Z" fill={color} />
        </svg>
    );
};
